import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core'
import swal from 'sweetalert'
import Stack from '@mui/material/Stack'
import * as Yup from 'yup'
import { useFormik } from 'formik'

import { insertManagementPlanMitigation } from '../../../../../services/Elegibilidad/create'
import { UpdateManagementPlanMitigation } from '../../../../../services/Elegibilidad/put'
import { getMitigationMeasures } from '../../../../../services/Elegibilidad/get'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'

export const Modal6 = ({
  openSec6,
  setOpenSec6,
  idEnviromentalImpact,
  edit,
  row,
  getDataTable,
  // setTableData,
  tableData,
  // IdManagementPlanMitigation,
  // setEdit,
}) => {
  const {
    idElegibilityForm,
    // EligibilityForm
  } = useFormElegibilidad()
  const [mitigationMeasures, setMitigationMeasures] = useState([])
  const [disabled, setDisabled] = useState(false)

  // const idElegibilityForm = 739
  // const EligibilityForm = {
  //   ImplementationDateStart: Date.now(),
  //   ImplementationDateEnd: new Date('Jul 01 2023'),
  // }
  const max = '2200-01-01'

  const EvaluationDataSchema = Yup.object().shape({
    StartDate: Yup.date()
      .required('Este campo es obligatorio')
      .max(new Date(max), `La fecha de inicio no debe ser mayor al 2200`),
    EndDate: Yup.date()
      .required('Este campo es obligatorio')
      .max(new Date(max), `La fecha fin no debe ser mayor al 2200`)
      .when(
        'StartDate',
        (StartDate, schema) =>
          StartDate &&
          schema.min(
            StartDate,
            'La fecha de finalizacion no puede ser menor a la fecha de inicio.',
          ),
      ),
    MitigationDetail: Yup.string().required('Este Campo es obligatorio'),
  })

  const formik = useFormik({
    initialValues: {
      IdManagementPlanMitigation: 0,
      EmpIdElegibilityAnswer: idElegibilityForm,
      EmpIdEnvironmentalImpact: idEnviromentalImpact,
      IdMitigationMeasure: 0,
      MitigationDetail: '',
      StartDate: '',
      EndDate: '',
    },
    validationSchema: EvaluationDataSchema,
    onSubmit: (values) => {
      handleGuardar()
    },
  })

  const getMitigationMeasuresList = async () => {
    try {
      const response = await getMitigationMeasures(idEnviromentalImpact)
      setMitigationMeasures(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const prepareToEdit = () => {
    if (edit) {
      formik.setValues({
        ...formik.values,
        IdManagementPlanMitigation: row.IdManagementPlanMitigation || -1,
        EmpIdEnvironmentalImpact:
          row.idEnviromentalImpact || idEnviromentalImpact,
        IdMitigationMeasure: row.IdMitigationMeasure || 0,
        MitigationDetail: row.MitigationDetail || '',
        StartDate: row.StartDate.slice(0, 10) || '',
        EndDate: row.EndDate.slice(0, 10) || '',
      })
    }
  }

  useEffect(() => {
    getMitigationMeasuresList()
    prepareToEdit()
  }, [])

  const handleGuardar = async () => {
    setDisabled(true)
    let saveData = { ...formik.values }

    if (formik.values.IdMitigationMeasure > 16) {
      saveData = {
        ...formik.values,
        MitigationDetail: null,
      }
    }

    try {
      if (idElegibilityForm) {
        if (edit) {
          const response = await UpdateManagementPlanMitigation(saveData)
          if (response.Success) {
            swal({
              title: '¡Datos actualizados exitosamente!',
              icon: 'success',
            })
          } else {
            throw Error(response.Message)
          }
        } else {
          const response = await insertManagementPlanMitigation(saveData)
          if (response.Success) {
            swal({
              title: '¡Datos guardados exitosamente!',
              icon: 'success',
            })
          } else {
            throw Error(response.Message)
          }
        }
      } else {
        throw Error('No se pudo obtener el ID del formulario')
      }
      handleClose()
      setDisabled(false)
    } catch (error) {
      console.log(error.message)
    }
  }

  const handleClose = () => {
    setOpenSec6(false)
    getDataTable(idElegibilityForm, idEnviromentalImpact)
  }

  return (
    <>
      <Modal
        open={openSec6}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form id="insertMitigations" onSubmit={formik.handleSubmit}>
          <Box className="modalPYME">
            <div className="pymeDiv">
              <h1 className="pymeTitle">Medidas de Mitigación</h1>
            </div>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Medidas</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    disabled={edit}
                    id="IdMitigationMeasure"
                    name="IdMitigationMeasure"
                    variant="outlined"
                    value={formik.values.IdMitigationMeasure || 0}
                    displayEmpty={true}
                    onChange={(e) => {
                      const detail =
                        e.target.value < 0 || e.target.value > 16
                          ? mitigationMeasures.find(
                              (item) =>
                                item.IdMitigationMeasure === e.target.value,
                            ).Description
                          : ''
                      formik.setValues(
                        {
                          ...formik.values,
                          IdMitigationMeasure: e.target.value,
                          MitigationDetail: detail,
                        },
                        true,
                      )
                    }}
                  >
                    <MenuItem disabled value="0">
                      Seleccione Medida
                    </MenuItem>
                    {(() => {
                      let uniqueMitigations = []
                      if (edit) {
                        uniqueMitigations = mitigationMeasures
                      } else {
                        const icludedIds = tableData.map(
                          (item) => item.IdMitigationMeasure,
                        )

                        if (
                          tableData.length > 0 &&
                          mitigationMeasures.length > 0
                        ) {
                          uniqueMitigations = mitigationMeasures.filter(
                            (item, key) => {
                              return !icludedIds.includes(
                                item.IdMitigationMeasure,
                              )
                            },
                          )
                        } else {
                          uniqueMitigations = mitigationMeasures
                        }
                      }
                      return uniqueMitigations.map((item, key) => (
                        <MenuItem key={key} value={item.IdMitigationMeasure}>
                          {item.Description}
                        </MenuItem>
                      ))
                    })()}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Medida</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    // disabled={
                    //   body.IdMitigationMeasure < 1 ||
                    //   body.IdMitigationMeasure > 16
                    // }
                    disabled={
                      formik.values.IdMitigationMeasure < 1 ||
                      formik.values.IdMitigationMeasure > 16
                    }
                    customInput={TextField}
                    onChange={(e) => {
                      // setBody({
                      //   ...body,
                      //   MitigationDetail: e.target.value,
                      // })
                      formik.setValues({
                        ...formik.values,
                        MitigationDetail: e.target.value,
                      })
                    }}
                    // value={body.MitigationDetail}
                    value={formik.values.MitigationDetail}
                  ></textarea>
                </FormControl>
                {formik.errors.MitigationDetail && (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.MitigationDetail}
                  </div>
                )}
              </Grid>

              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-stretch',
                }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Fecha Inicio</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <Stack component="form" noValidate spacing={3}>
                          <TextField
                            id="StartDate"
                            type="date"
                            name="StartDate"
                            variant="outlined"
                            required
                            // defaultValue={formik.ImplementationDateStart}
                            sx={{ width: 220 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              min: '2021-06-30',
                            }}
                            // value={body.StartDate}
                            value={formik.values.StartDate}
                            onChange={(e) => {
                              formik.setValues(
                                {
                                  ...formik.values,
                                  StartDate: e.target.value,
                                },
                                true,
                              )
                            }}
                          />
                        </Stack>
                      </FormControl>
                    </Grid>
                  </Grid>
                  {formik.errors.StartDate ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.StartDate}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Fecha Fin</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <Stack component="form" noValidate spacing={3}>
                          <TextField
                            id="EndDate"
                            type="date"
                            name="EndDate"
                            variant="outlined"
                            sx={{ width: 220 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              min: formik.values.StartDate || '2021-06-30',
                            }}
                            // value={body.EndDate}
                            value={formik.values.EndDate}
                            disabled={formik.values.StartDate === ''}
                            onChange={(e) => {
                              // setBody({
                              //   ...body,
                              //   EndDate: e.target.value,
                              // })
                              formik.setValues(
                                {
                                  ...formik.values,
                                  EndDate: e.target.value,
                                },
                                true,
                              )
                            }}
                          />
                        </Stack>
                      </FormControl>
                    </Grid>
                  </Grid>
                  {formik.errors.EndDate ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.EndDate}
                    </div>
                  ) : null}
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  className="confirmButton"
                  // onClick={handleGuardar}
                  disabled={disabled}
                >
                  {edit ? 'Actualizar' : 'Guardar'}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Modal>
    </>
  )
}
